import { QCChecklistTemplateItem } from './qc-checklist-template-item.model';

/**
 * jsonb-stored body shape: schemaVersion + flat items array.
 * Mirrors backend QCChecklistTemplateBody / QCChecklistTemplateBodyViewModel.
 */
export interface QCChecklistTemplateBody {
    readonly schemaVersion: number;
    readonly items: ReadonlyArray<QCChecklistTemplateItem>;
}
